
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CategoryTabs',
  props: {
    repairReasonId: {
      type: String,
      default: ''
    },
    repairReasons: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  emits: ['change'],

  methods: {
    getIconClass(repairReasonId: string) {
      switch (repairReasonId) {
        case 'c1661393-0a81-47f2-8a08-2aabdd8cfcd5':
          return 'icon-brake-disc';
        case '5406e9df-7b38-47ff-bb55-249aa9ca6267':
          return 'icon-ac';
        case 'dbb83bd4-e475-499a-9f9a-79a74654b7c5':
          return 'icon-tires';
        case '275a4ad6-b581-402c-b555-f28db469ed37':
          return 'icon-wash';
        case '1c183c5b-3803-481b-a089-783802e0ec05':
          return 'icon-carreview';
        case 'b1ed3dd8-c269-4956-9059-3b3e6ea27906':
          return 'icon-cardiagnostic';
        case '09f59f41-a7c3-44d2-ba0a-4edb7fa6c613':
          return 'icon-carcheck';
        case '219f54f3-4c53-4a67-99c7-f4637e6c2036':
          return 'icon-toe-in';
        default:
          return 'icon-others';
      }
    }
  }
});
